export default __webpack_public_path__ + "scripts/resources/assignments/en/oracle-2_2/species.json";